import { createFileRoute } from '@tanstack/react-router';

import { CurrencyPage } from '@/features/logbook';

export const Route = createFileRoute('/logbook/currency')({
  component: CurrencyPage,
});
